export const TAG = 'raptora.widget.v1' as const
